import { render } from "./GradeCheck.vue?vue&type=template&id=21818292&scoped=true"
import script from "./GradeCheck.vue?vue&type=script&lang=js"
export * from "./GradeCheck.vue?vue&type=script&lang=js"

import "./GradeCheck.vue?vue&type=style&index=0&id=21818292&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21818292"]])

export default __exports__